import { useRef, useEffect } from 'react'

interface Props {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

export function OtpInput({ value, onChange, disabled }: Props) {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  function handleChange(raw: string) {
    const digits = raw.replace(/\D/g, '').slice(0, 6)
    onChange(digits)
  }

  return (
    <div className="flex justify-center">
      <input
        ref={inputRef}
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        value={value}
        disabled={disabled}
        onChange={e => handleChange(e.target.value)}
        placeholder="000000"
        className="w-64 text-center text-3xl font-mono tracking-[0.3em] py-3 rounded-lg
          border-2 border-gray-300 focus:border-brand-500 focus:ring-2 focus:ring-brand-500
          disabled:bg-gray-100 disabled:text-gray-400"
      />
    </div>
  )
}
